// fn_get_aim_snapshot resolves to a single latest snapshot, which Supabase
// returns as a 1-row array (RETURNS TABLE). Consumers (HeadlineMetrics,
// ProvidersTab, DiagnosticsTab, GoogleOrganicTab) read snap.value_numeric /
// snap.value_breakdown and expect a single object — so unwrap the array here.
/**
 * @param {Array<object>|object|null|undefined} data Raw snapshot RPC payload.
 * @returns {object|null} The single snapshot row (first element if an array), or null.
 */
export function unwrapSnapshot(data) {
  if (Array.isArray(data)) return data[0] ?? null;
  return data ?? null;
}
